import { connect } from 'react-redux';
import { showModal } from '@redux/modules/ui/modal';
import ImportMenu from './ImportMenu';

export default connect(null, { showModal })(ImportMenu);
